import { createSelector } from "reselect";

const currentCategory = ({ categories, categoryName }) => {
  for (const categoryType of categories) {
    for (const category of categoryType.categories) {
      if (category.url === categoryName) {
        return category;
      }
    }
  }
};

export const getCurrentCategory = createSelector(currentCategory, item => item);
